module.exports = __webpack_public_path__ + "static/media/spades-jack.0213aa73.png";